// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { MessageBar, MessageBarType, Stack } from '@fluentui/react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const E = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();
  const [fetchCompleted, setFetchCompleted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirectUri = params.get('redirectUri');

    fetch('/api/login/logout', { credentials: 'include' })
      .then(() => {
        if (redirectUri) {
          navigate(redirectUri);
        }
      })
      .catch((e) => {
        setError(e instanceof Error ? e.message : 'Unable to log out.');
      })
      .finally(() => setFetchCompleted(true));
  }, [location.search, navigate]);

  if (!fetchCompleted) {
    return <></>;
  }

  return (
    <Stack tokens={{ childrenGap: 12 }} styles={{ root: { maxWidth: 720, margin: '32px auto' } }}>
      {error ? (
        <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
          {error}
        </MessageBar>
      ) : (
        <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
          You have been logged out.
        </MessageBar>
      )}
    </Stack>
  );
};

export default E;
